import { render, staticRenderFns } from "./ProductCourse.vue?vue&type=template&id=6f5cd798&scoped=true"
import script from "./ProductCourse.vue?vue&type=script&lang=ts"
export * from "./ProductCourse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5cd798",
  null
  
)

export default component.exports